import React, { useEffect, useRef, useState } from "react";
import TopBar from "../other-components/TopBar";
import LoadingDialog from "../dialogs/LoadingDialog/dialog";
import "../../MainStyle.css";
import { API_ACCESS_URL, getURLParam } from "../modals/Constants";
import { getStorage } from "../modals/Storage";
import general from "../css/General.module.css";

function TradeRecords() {
  const listViewRef = useRef();
  const [isLoadingShow, setLoadingShow] = useState(false);

  const [pageConst, setConstants] = useState({
    pageTitle: "Trade Records",
    recordList: [],
  });

  const topBarClickAction = (data) => { };

  function getTradeRecords() {
    const requestAPI = async (url, formData) => {
      try {
        const res = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            route: "route-trade-records",
            AuthToken: getStorage("secret"),
          },
          body: JSON.stringify(formData),
        });
        const data = await res.json();
        setLoadingShow(false);

        if (data.status_code == "success") {
          setConstants({
            ...pageConst,
            recordList: data.data,
          });
        }
      } catch (error) {
        setLoadingShow(false);
      }
    };

    if (!isLoadingShow) {
      setLoadingShow(true);
      const formData = {
        ACCOUNT_ID: getStorage("uid"),
        SERVICE_ID: getURLParam('id')
      };
      requestAPI(API_ACCESS_URL, formData);
    }
  }

  useEffect(() => {
    getTradeRecords();
  }, []);

  // useEffect(() => {
  //   if (getURLParam('id') == null || getURLParam('id') == "") {
  //     signOutAccount();
  //   }
  // }, []);

  const onScroll = () => {
    if (listViewRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listViewRef.current;
      const isNearBottom = scrollTop + clientHeight >= scrollHeight;

      if (isNearBottom) {
        let newPageVal = pageConst.pageCount + 1;
        setConstants(previousState => {
          return { ...previousState, pageCount: newPageVal }
        });
      }
    }
  }

  return (
    <div className={[general.appContents].join(" ")}>
      <TopBar
        intentData={pageConst}
        multiBtn={true}
        multiBtn1=""
        multiBtn2=""
        background={1}
        updateState={topBarClickAction}
      />
      <LoadingDialog intentData={isLoadingShow} />

      <div
        className={[
          general.posRelative,
          general.respWidth,
          general.height100vh,
          general.overflowScrollY,
          general.hideScrollBar,
        ].join(" ")}
        ref={listViewRef}>

        <div className="col-view mg-t-55">
          {pageConst.recordList.length > 0 ? pageConst.recordList.map(item => {
            return (
              <div className="row-view sb-view pd-15" key={item.id}>
                <div className="col-view">
                  <div className="row-view">
                    <img
                      src={item.icon}
                      className={`h-w-20`}
                      alt="icon"
                    />

                    {item.trade == "CALL" ?
                      <div className="h-w-20 v-center ft-sz-18 cl-white br-50 bg-green mg-l-5">
                        <i className='bx bx-up-arrow-alt'></i>
                      </div> :
                      <div className="h-w-20 v-center ft-sz-18 cl-white br-50 bg-red mg-l-5">
                        <i className='bx bx-down-arrow-alt'></i>
                      </div>
                    }

                    <p className="cl-white mg-l-10">{item.interval}M-{item.trade}</p>
                  </div>
                  <p className="ft-sz-14 cl-l-white-2 mg-t-5">Time: {item.datetime}</p>
                </div>

                <p className={`${item.status == 'profit' ? 'cl-green' : item.status == 'loss' ? 'cl-red' : 'cl-golden'}`}>{item.status == 'profit' ? '+' : item.status == 'loss' ? '-' : ''}₹{item.amount}</p>
              </div>
            )
          }) : <div className="pd-15 cl-white">No records found.</div>}
        </div>

      </div>
    </div>
  );
}

export default TradeRecords;
